import './upload-result.scss';

import React from 'react';

import { TypeButton } from '../../utils/button';
import { CopyValue } from '../../utils/copy';
import { ArrowRightSVG, CheckSVG, ClockSVG, EyeSVG, VerifiedSVG } from '../../utils/svgs';

interface IUploadResultStatusStage {
	onView: () => void;
	onNext: () => void;
	fileCount?: number;
	uploadedAt?: string;
	assignmentName?: string;
	assignmentCode?: string;
}

const UploadResultStatusStage = ({
	onNext,
	onView,
	fileCount,
	uploadedAt,
	assignmentName,
	assignmentCode,
}: IUploadResultStatusStage) => (
	<div
		className='f-column-33'
		role='status'
		aria-live='polite'
	>
		<div className='upload-result-success'>
			<div
				className='upload-result-success__icon'
				role='img'
				aria-label='Upload successful'
			>
				<CheckSVG
					color='var(--success-500)'
					width='32'
					height='32'
				/>
			</div>
			<h3 className='upload-result-success__title'>Upload Successful</h3>
			<p className='upload-result-success__subtitle'>
				The election result sheet has been securely uploaded and is ready for processing
			</p>
			<div className='upload-result-success__verified-badge'>
				<VerifiedSVG
					color='var(--success-600)'
					width='14'
					height='14'
				/>
				<span>Secured & Verified</span>
			</div>
			{(fileCount || uploadedAt || assignmentName) && (
				<div className='upload-result-success__details'>
					{assignmentName && (
						<div className='upload-result-success__detail-row'>
							<span className='upload-result-success__detail-row-label'>Assigned Area</span>
							<span className='upload-result-success__detail-row-value'>
								{assignmentName}
								{assignmentCode && (
									<span className='upload-result-success__detail-row-code'>
										{assignmentCode}
										<CopyValue
											value={assignmentCode}
											label='code'
											size={14}
										/>
									</span>
								)}
							</span>
						</div>
					)}
					{!!fileCount && (
						<div className='upload-result-success__detail-row'>
							<span className='upload-result-success__detail-row-label'>Files Uploaded</span>
							<span className='upload-result-success__detail-row-value'>
								{fileCount} {fileCount === 1 ? 'file' : 'files'}
							</span>
						</div>
					)}
					{uploadedAt && (
						<div className='upload-result-success__detail-row'>
							<span className='upload-result-success__detail-row-label'>
								<ClockSVG
									color='var(--neutral-500)'
									width='12'
									height='12'
								/>
								Uploaded
							</span>
							<span className='upload-result-success__detail-row-value'>{uploadedAt}</span>
						</div>
					)}
				</div>
			)}
		</div>
		<div className='upload-result__actions upload-result__actions--status'>
			<TypeButton
				title='Next — Election Result Summary'
				buttonSize='medium'
				onClick={onNext}
				className='w-100'
				icon={<ArrowRightSVG color='#fff' />}
				aria-label='Continue to election result summary'
			/>
			<TypeButton
				title='View Uploaded Result'
				buttonSize='small'
				onClick={onView}
				className='w-100'
				buttonType='outlined'
				icon={<EyeSVG />}
				aria-label='View the uploaded election result sheet'
			/>
		</div>
	</div>
);

export default UploadResultStatusStage;
